/* ─── Alert ─── */

.root {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--shape-sm);
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
}

/* ─── Severity variants ─── */

.info {
  background: var(--md-primary-container);
  color: var(--md-on-primary-container);
}

.success {
  background: var(--status-success-container);
  color: var(--md-on-surface);
}

.warning {
  background: var(--status-pending-container);
  color: var(--md-on-surface);
}

.error {
  background: var(--md-error-container);
  color: var(--md-on-error-container);
}

/* ─── Icon ─── */

.icon {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-block-start: 0.125rem;
}

.info .icon {
  color: var(--md-primary);
}

.success .icon {
  color: var(--status-success);
}

.warning .icon {
  color: var(--status-pending);
}

.error .icon {
  color: var(--md-error);
}

/* ─── Content ─── */

.content {
  flex: 1;
  min-width: 0;
}

/* ─── Title ─── */

.title {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-weight: 600;
  margin: 0;
}

.title + .message {
  margin-block-start: var(--space-1);
}

/* ─── Message ─── */

.message {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  margin: 0;
  overflow-wrap: break-word;
}

/* ─── Close button ─── */

.close {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  margin-block-start: -0.125rem;
  margin-inline-end: calc(-1 * var(--space-1));
  border: none;
  border-radius: var(--shape-full);
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.close::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .close:hover::before {
    opacity: var(--state-hover);
  }
}

.close:focus-visible::before {
  opacity: var(--state-focus);
}

.close:active::before {
  opacity: var(--state-pressed);
}

.close:focus-visible {
  --focus-ring-color: currentColor;
}

.close svg {
  width: 1rem;
  height: 1rem;
}

/* ─── Reduced motion ─── */

@media (prefers-reduced-motion: reduce) {
  .close::before {
    transition: none;
  }
}
